import { getSSOForEmail, getUriForEmail } from 'utils/api'
import yup from 'yup'
import debounce from 'lodash/debounce'

const emailSchema = yup.string().email()

export const getSSOForEmailInput = debounce(
  (value, callback) =>
    emailSchema
      .isValid(value)
      .then(isEmail => isEmail && getSSOForEmail(value).then(callback)),
  300
)
export const getUriForEmailInput = debounce(
  (value, callback, rejectCallback) =>
    emailSchema
      .isValid(value)
      .then(isEmail => isEmail && getUriForEmail(value).then(callback).catch(rejectCallback)),
  300
)



// WEBPACK FOOTER //
// ./src/utils/sso.js